import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class CumplimientoMetasService {

    private url = `${environment.services_url}`;

    constructor(private http: HttpClient) { }

    obtenerTodos(): Observable<any> {
        return this.http.get<any[]>(`${this.url}/promocion/metasCumplidas`);
    }

    autorizarPago(metaPromocionId: number): Observable<any> {
        return this.http.get(`${this.url}/promocion/metasCumplidas/${metaPromocionId}`);
    }

    ejecutarCalculoMetas(): Observable<any> {
        return this.http.post(`${this.url}/promocion/0/meta/evaluarMetas`, {});
    }

    obtenerDetalle(asesorMetaCumplidaId: number): Observable<any> {
        return this.http.get<any>(
            `${this.url}/promocion/metasCumplidas/detalleRetroactivo/${asesorMetaCumplidaId}`
        );
    }

    eliminarMetaCumplida(metaPromocionId: number): Observable<any> {
        return this.http.delete(`${this.url}/promocion/metasCumplidas/${metaPromocionId}`);
    }

    autorizarTodo(ids: number[]): Observable<any> {
        return this.http.post<any>(
            `${this.url}/promocion/metasCumplidas/autorizar-todo`,
            { ids }
        );
    }
}